import fs from 'fs';
import path from 'path';
import os from 'os';

if (typeof process === "undefined") {
    throw new Error("@putkoff/abstract-env is Node-only");
}
/* ========================================================================== */
/* Utilities                                                                  */
/* ========================================================================== */
function splitEq(line) {
    const idx = line.indexOf("=");
    if (idx === -1)
        return [line.trim(), null];
    const key = line.slice(0, idx).trim();
    const value = line.slice(idx + 1).trim().replace(/^['"]|['"]$/g, "");
    return [key, value];
}
/* ========================================================================== */
/* AbstractEnv                                                                */
/* ========================================================================== */
class AbstractEnv {
    key;
    fileName;
    path;
    deepScan;
    currentFolder;
    homeFolder;
    envyAll;
    directories = [];
    envValue = null;
    envPath = null;
    constructor(options = {}) {
        this.key = options.key ?? "MY_PASSWORD";
        this.fileName = options.fileName ?? ".env";
        this.path = options.startPath ?? process.cwd();
        this.deepScan = options.deepScan ?? false;
        this.currentFolder = process.cwd();
        this.homeFolder = os.homedir();
        this.envyAll = path.join(this.homeFolder, ".envy_all");
        this.initialize();
    }
    initialize() {
        if (fs.existsSync(this.path) && fs.statSync(this.path).isFile()) {
            this.fileName = path.basename(this.path);
            this.path = path.dirname(this.path);
        }
        this.directories = this.getDirectories();
        this.envValue = this.findAndReadEnv();
    }
    getDirectories() {
        const dirs = [
            this.path,
            this.currentFolder,
            this.homeFolder,
            this.envyAll,
        ];
        return [...new Set(dirs.filter(d => fs.existsSync(d) && fs.statSync(d).isDirectory()))];
    }
    findAndReadEnv() {
        for (const dir of this.directories) {
            const envPath = path.join(dir, this.fileName);
            if (!fs.existsSync(envPath))
                continue;
            this.envPath = envPath;
            const value = this.searchForKey(envPath);
            if (value !== null)
                return value;
        }
        return null;
    }
    searchForKey(filePath) {
        const content = fs.readFileSync(filePath, "utf8");
        const lines = content.split(/\r?\n/);
        let bestMatch = null;
        for (const line of lines) {
            const [lineKey, lineValue] = splitEq(line);
            if (!lineValue)
                continue;
            if (lineKey === this.key)
                return lineValue;
            if (this.deepScan) {
                const score = this.fuzzyScore(this.key, lineKey);
                if (score >= 0.5 && (!bestMatch || score > bestMatch.score)) {
                    bestMatch = { value: lineValue, score };
                }
            }
        }
        return bestMatch?.value ?? null;
    }
    fuzzyScore(target, candidate) {
        let matched = 0;
        for (const part of target.split("_")) {
            if (candidate.includes(part))
                matched += part.length;
        }
        return matched / target.length;
    }
}

/**
 * Retrieve environment variable value by searching .env files.
 */
function getEnvValue(options = {}) {
    const env = new AbstractEnv(options);
    return env.envValue;
}
/**
 * Retrieve the path of the resolved .env file.
 */
function getEnvPath(options = {}) {
    const env = new AbstractEnv(options);
    return env.envPath;
}

export { AbstractEnv, getEnvPath, getEnvValue };
//# sourceMappingURL=index.js.map
